import React, {useEffect, useRef, useState} from 'react';

const DynamicScalingWrapper = ({children, cash}) => {
    const containerRef = useRef(null);
    const [scale, setScale] = useState(1);
    const resizeObserverRef = useRef(null);
    const [xTranslate, setXTranslate] = useState(30);
    const [baseWidth, setBaseWidth] = useState(65);

    useEffect(() => {

        function calculateBaseWidthAndXTranslate(amount) {
            const points = [
                [1_00, 65, 16],
                [5_00, 60, 16],
                [9_00, 55, 16],
                [10_00, 65, 16],
                [99_00, 60, 8],
                [100_00, 70, 5],
                [999_00, 72, 5],
                [1_000_00, 87, 2],
                [9_999_00, 88, 0],
                [10_000_00, 95, 0],
                [99_999_00, 98, 0],
                [100_000_00, 105, -2],
                [999_999_00, 105, -2],
                [1_000_000_00, 120, -2],
                [9_999_999_00, 120, -2],
                [10_000_000_00, 125, -4],
            ];

            let width, translate;

            if (amount <= points[0][0]) {
                [, width, translate] = points[0];
            } else if (amount >= points.at(-1)[0]) {
                [, width, translate] = points.at(-1);
            } else {
                for (let i = 0; i < points.length - 1; i++) {
                    const [x1, w1, t1] = points[i];
                    const [x2, w2, t2] = points[i + 1];

                    if (amount >= x1 && amount <= x2) {
                        const ratio = (amount - x1) / (x2 - x1);
                        width = w1 + ratio * (w2 - w1);
                        translate = t1 + ratio * (t2 - t1);
                        break;
                    }
                }
            }

            setBaseWidth(width);
            setXTranslate(translate);
        }

        calculateBaseWidthAndXTranslate(cash);

    }, [cash]);


    useEffect(() => {
        if (!containerRef.current || !containerRef.current.parentElement) {
            return;
        }

        const updateScale = () => {
            if (!containerRef.current || !containerRef.current.parentElement) {
                return;
            }
            const parentWidth = containerRef.current.parentElement.offsetWidth;
            const newScale = parentWidth / baseWidth;
            setScale(newScale);
        };

        updateScale();

        // Store observer in a ref to clean it up correctly
        const observerRef = resizeObserverRef.current;
        if (observerRef) {
            observerRef.disconnect(); // Properly clean up previous observer before creating a new one
        }

        const resizeObserver = new ResizeObserver(updateScale);
        resizeObserver.observe(containerRef.current.parentElement);
        resizeObserverRef.current = resizeObserver; // Save reference

        return () => {
            if (resizeObserverRef.current) {
                resizeObserverRef.current.disconnect(); // Cleanup on unmount or re-run
            }
        };
    }, [baseWidth]);

    return (
        <div
            ref={containerRef}
            style={{
                transform: `scale(${scale}) translateX(${xTranslate}%) translateY(50%)`,
                transformOrigin: '0 0',
                width: `${baseWidth}px`,
            }}
        >
            {children}
        </div>
    );
};

export default DynamicScalingWrapper;